@use 'sass:map';
@use 'ui/styles/core-tokens' as core;

.item {
  box-sizing: border-box;
  margin-bottom: 8px;
  overflow: hidden;
  padding: 10px 26px;
  white-space: nowrap;
  width: 100%;

  &Content {
    align-items: center;
    display: flex;

    &Name {
      padding-left: 12px;
    }
  }

  svg {
    color: map.get(core.$colors, simpleWhite);
  }

  &Active {
    background-color: rgba(map.get(core.$colors, simpleWhite), 0.4);

    span {
      font-weight: bold;
    }
  }

  &Collapsed {
    padding-left: 20px;
  }

  &:hover:not(.itemActive) {
    background-color: rgba(map.get(core.$colors, simpleWhite), 0.4);
  }
}
